export const navigationItems = [
  {
    path: '/',
    text: 'Главная',
  },
  {
    path: '/about-us/',
    text: 'О нас',
  },
  {
    path: '/socially/',
    text: 'Социально-ориентированная деятельность',
  },
  {
    path: '/competitions/',
    text: 'Конкурсы',
  },
  {
    path: '/shop/',
    text: 'Магазин',
  },
  {
    path: '/services/',
    text: 'Услуги',
    activePrefixes: ['/services/'],
  },
  {
    path: '/strelets-monitoring/',
    text: 'Стрелец-Мониторинг',
    activePaths: ['/services/strelets-monitoring/'],
  },
  {
    path: '/all-news/',
    text: 'Новости',
  },
  {
    path: '/education/',
    text: 'Сведения об образовательной деятельности',
  },
  {
    path: '/contacts/',
    text: 'Контакты',
  },
  {
    path: '/game/',
    text: 'Игра',
    variant: 'accent',
  },
];
